import Form from "../form/Form";
import { useParams } from "react-router";
import { MainContainerForm, MainPadding } from "../../../styles/Main.styles";

export default function Creation() {
  const { idSupplier } = useParams();

  return (
    <MainPadding>
      <MainContainerForm>
        <Form idSupplier={idSupplier} />
      </MainContainerForm>
    </MainPadding>
  );
}
